var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSwitcherNews(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 19.5,
    cy: 19.5,
    r: 18.5,
    fill: "white",
    stroke: "#E8EBEB"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 16L14.2265 26H25.7735L20 16ZM21 33V25H19V33H21Z",
    fill: "#006998"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M29.5 12.5C29.5 12.5593 29.4399 12.7589 28.9597 13.0427C28.5131 13.3067 27.8334 13.5618 26.9498 13.7827C25.1902 14.2226 22.7329 14.5 20 14.5C17.2671 14.5 14.8098 14.2226 13.0502 13.7827C12.1666 13.5618 11.4869 13.3067 11.0403 13.0427C10.5601 12.7589 10.5 12.5593 10.5 12.5C10.5 12.4407 10.5601 12.2411 11.0403 11.9573C11.4869 11.6933 12.1666 11.4382 13.0502 11.2173C14.8098 10.7774 17.2671 10.5 20 10.5C22.7329 10.5 25.1902 10.7774 26.9498 11.2173C27.8334 11.4382 28.5131 11.6933 28.9597 11.9573C29.4399 12.2411 29.5 12.4407 29.5 12.5Z",
    fill: "#006998",
    stroke: "#006998"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSwitcherNews);
export default __webpack_public_path__ + "static/media/SwitcherNews.922c94017e9b5afeb6bd16a997e8fb22.svg";
export { ForwardRef as ReactComponent };